// extracted by mini-css-extract-plugin
module.exports = {"uploaded":"DocumentsForm_uploaded__toIx5","container":"DocumentsForm_container__2WopS","name":"DocumentsForm_name__VKEyV"};